<div class="container">
  <h1 mat-dialog-title>{{ title }}</h1>
  <div class="content" mat-dialog-content>{{ description }}</div>
  <div class="buttons" mat-dialog-actions>
    <button mat-button cdkFocusInitial mat-dialog-close>{{ buttonTitleNo }}</button>
    <button mat-button [mat-dialog-close]="'YES'">{{ buttonTitleYes }}</button>
  </div>
</div>
